import styled from 'styled-components';
import Button, { createButtonTransition } from 'components/Button';
import { getThemeColor, getThemeTypography } from 'utils/styled';
import { HORIZONTAL_PADDING } from './constants';
import { SocialButtonStyleProps } from './types';

const centerAlignStyle = `
  padding: 14px ${HORIZONTAL_PADDING};
`;

const rightAlignStyle = `
  padding: 14px 24px;
  justify-content: flex-end;
`;

const alignmentStyles = {
  center: centerAlignStyle,
  right: rightAlignStyle,
};

export const Root = styled(Button).attrs({
  variant: 'ghost',
})<SocialButtonStyleProps>`
  transition: ${createButtonTransition(['border-color', 'background-color'])};
  background-color: ${getThemeColor('l2')};
  min-width: 275px;
  position: relative;

  ${({ $textAlign }) => alignmentStyles[$textAlign]}

  ${getThemeTypography('h2')};
  letter-spacing: normal;
  text-transform: none;

  &,
  &[data-hovered='true'],
  &[disabled] {
    border: 1px solid ${getThemeColor('l4')};
  }

  &[data-hovered='true'] {
    background-color: ${getThemeColor('l3')};
  }

  &,
  &[data-hovered='true'],
  &[disabled] {
    color: ${getThemeColor('d1')};
  }
`;

export const LogoContainer = styled.div`
  color: inherit;
  // this should be the same height that the text occupies, which is
  // is font-size * line-height.  font-size is 14px, line-height is 1.5, giving
  // 14 * 1.5 = 21px;
  height: 21px;
  left: ${HORIZONTAL_PADDING};
  position: absolute;

  * {
    height: 100%;
    width: auto;
  }
`;
